<lib-select [options]="options"
            data-testid="language-switch-select"
            [label]="label"
            [itemClasses]="'font-weight-bold text-center font-size-small'"
            [classes]="'font-weight-bold ml-1 text-primary ' + (headerResponsivenessOptions?.hideTimezoneSwitch ? 'font-size-small' : 'font-size-normal')"
            [enableSearch] = "false"
            (selectedChanged)="handleSelectedChanged($event)">
</lib-select>